import i from "./index873.js";
import { openBlock as o, createElementBlock as s, normalizeStyle as n, normalizeClass as r, renderSlot as l, createCommentVNode as t } from "vue";
import d from "./index720.js";
function a(e, p, m, f, u, $) {
  return o(), s(
    "div",
    {
      class: r([e.ns.b("dropdown"), e.ns.is("multiple", e.isMultiple), e.popperClass]),
      style: n({ [e.isFitInputWidth ? "width" : "minWidth"]: e.minWidth })
    },
    [
      e.$slots.header ? (o(), s(
        "div",
        {
          key: 0,
          class: r(e.ns.be("dropdown", "header"))
        },
        [
          l(e.$slots, "header")
        ],
        2
        /* CLASS */
      )) : t("v-if", !0),
      l(e.$slots, "default"),
      e.$slots.footer ? (o(), s(
        "div",
        {
          key: 1,
          class: r(e.ns.be("dropdown", "footer"))
        },
        [
          l(e.$slots, "footer")
        ],
        2
        /* CLASS */
      )) : t("v-if", !0)
    ],
    6
    /* CLASS, STYLE */
  );
}
var w = /* @__PURE__ */ d(i, [["render", a]]);
export {
  w as default
};
